import EventEmitter from "eventemitter3";
const eventBus = new EventEmitter();

export const EVENTS_NAMES = {
    // 新用户身份变动
    NEW_USER_CHANGED: "NEW_USER_CHANGED",
    // session过期403
    SESSION_EXPIRED: "SESSION_EXPIRED",
};

export const waitEvent = (eventName: string, timeout = 0) => {
    let timer = null;
    return new Promise((resolve) => {
        if (timeout > 0) {
            timer = setTimeout(() => {
                eventBus.removeListener(eventName, handler);
                resolve(null);
            }, timeout);
        }
        const handler = (data: any) => {
            eventBus.removeListener(eventName, handler);
            resolve(data);
        };
        eventBus.on(eventName, handler);
    });
};

export default eventBus;
